import apiClient from '../apiClient';
import { POST_CITY_URL } from '../apiUrl';

const postCityApi = data => {
  return apiClient.post(POST_CITY_URL, data);
};

export default postCityApi;
